export function splitFileExtension(filename: string | undefined) {
    if (!filename) return undefined;
    const separator = filename.lastIndexOf(".");
    if (separator < 0) return { filename, extension: "" };
    return {
        filename: filename.substring(0, separator),
        extension: filename.substring(separator),
    };
}
